'use strict';

(function () {
	angular.module('natiwi.navigation-menu', ['natiwi.core.cdn']);
})();